
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'TransferService',
  mixins: [staticBlockMixin],
  inject: [
    'setGlobalFormProviderProperties'
  ],
  props: {
    isReverse: {
      type: Boolean,
      required: false,
      default: false
    },
    needPercents: {
      type: Boolean,
      default: false
    },
    fullImage: {
      type: Boolean,
      required: false,
      default: false
    },
    showDivider: {
      type: Boolean,
      required: false,
      default: false
    }

  },

  fetch () {
    if (+this.$route?.query?.form === this.mainFields?.form?.value) {
      this.setFormSettings()
    }
  },
  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.mainFields?.form?.value,
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong
      })
    },
    openModal () {
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.mainFields?.form?.value } })
    }
  }
})
